import type { ReactNode } from 'react';

interface CollapsibleControlSectionProps {
  title: string;
  summary: string;
  badge?: ReactNode;
  badgeClassName?: string;
  isOpen: boolean;
  onToggle: () => void;
  intro?: boolean;
  className?: string;
  children: ReactNode;
}

export function CollapsibleControlSection({
  title,
  summary,
  badge,
  badgeClassName = '',
  isOpen,
  onToggle,
  intro = false,
  className = '',
  children,
}: CollapsibleControlSectionProps) {
  return (
    <section
      className={`control-section collapsible-control-section${intro ? ' control-section--intro' : ''}${className ? ` ${className}` : ''}`}
    >
      <button
        type="button"
        className="control-section-toggle"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <span className="control-section-chevron" aria-hidden="true">
          {isOpen ? '−' : '+'}
        </span>
        <span className="control-section-title">
          <strong>{title}</strong>
          <small>{summary}</small>
        </span>
        {badge !== undefined && (
          <span className={`badge${badgeClassName ? ` ${badgeClassName}` : ''}`}>{badge}</span>
        )}
      </button>
      {isOpen && <div className="collapsible-control-content">{children}</div>}
    </section>
  );
}
